import Text from '@atoms/Text/Text';
import classNames from 'classnames';
import { TextareaHTMLAttributes } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

export interface ITextArea extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  readonly id: string;
  readonly name: string;
  readonly helperText?: string;
  readonly registerOptions?: RegisterOptions;
  readonly label?: string;
}

const TextArea = ({
  registerOptions,
  name,
  helperText,
  label,
  className,
  disabled,
  ...rest
}: ITextArea) => {
  const { register, formState } = useFormContext();
  const error = formState.errors[name];
  const errorMessage = typeof error?.message === 'string' ? error.message : '';

  return (
    <div className="tw-grid tw-gap-2">
      {label && (
        <Text
          as="label"
          htmlFor={rest.id}
          variant="label-12"
          className="tw-text-grey-70"
        >
          {label}
          {registerOptions?.required ? ' *' : ''}
        </Text>
      )}
      <textarea
        {...rest}
        {...register(name, registerOptions)}
        disabled={disabled}
        className={classNames(
          'tw-rounded tw-border tw-bg-transparent tw-p-4 tw-text-sm tw-text-grey-100 tw-outline-none tw-outline-1 -tw-outline-offset-1 focus:tw-outline-black',
          {
            className,
            'tw-border-red tw-pr-lg focus-within:tw-outline-red': error,
            'tw-border-grey-40 tw-text-grey-40 placeholder:tw-text-grey-40':
              disabled,
            'tw-border-grey-60 placeholder:tw-text-grey-70 focus-within:tw-border-grey-100 focus-within:tw-outline-2':
              !error && !disabled,
          }
        )}
      />
      {helperText && (
        <Text variant="label-12" className="tw-text-grey-70">
          {helperText}
        </Text>
      )}
      {errorMessage && (
        <Text variant="label-12" className="tw-text-red" role="alert">
          {errorMessage}
        </Text>
      )}
    </div>
  );
};

export default TextArea;
